import { format } from "date-fns";
import { useEffect, useState } from "react";
import { BsPlayBtnFill } from "react-icons/bs";
import { FaFilePdf } from "react-icons/fa6";
import { FiEdit } from "react-icons/fi";
import { LuEye } from "react-icons/lu";
import { MdAutoDelete, MdDelete, MdInfo } from "react-icons/md";
import { PiListChecksFill } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import Button from "../../../Components/Button/index.jsx";
import CardProgressao from "../../../Components/ProgressaoParcial/CardAddEditProgressao/index.jsx";
import CardGerarResultadoProgressao from "../../../Components/ProgressaoParcial/CardGerarResultProgre/index.jsx";
import CardListarAlunosPP from "../../../Components/ProgressaoParcial/CardListarAlunosPP/index.jsx";
import CardVerInformacoes from "../../../Components/ProgressaoParcial/CardVerInformacoes/index.jsx";
import CardVerPdfProgressao from "../../../Components/ProgressaoParcial/CardVerPdfProgressao/index.jsx";
import InsirirVerDocExemplar from "../../../Components/ProgressaoParcial/InsirirDocExemplar/index.jsx";
import api from "../../../Services/api.js";
import { Alert } from "../../../utils/Alert.js";
import Loading from "../../../utils/Loading";
import {
  Buttons,
  ContainerTable,
  Description,
  Description2,
  DivMain,
  DivText,
  Menus,
  Page,
  Table,
  Tbody,
  Td,
  TdDisciplina,
  Th,
  Theader,
  Title,
  Trbody,
} from "./styles";

export const ProgressaoParcialCoordenador = () => {
  const Navigate = useNavigate();
  const [progressaoEdit, setProgressaoEdit] = useState([]);
  const [showAdicionar, setShowAdicionar] = useState(false);
  const [resultado, setResultado] = useState(false);
  const [showEditar, setShowEditar] = useState(false);
  const [MostrarAlunos, setMostrarAlunos] = useState(false);
  const [showConfirmarDelete, setShowConfirmarDelete] = useState(false);
  const [progressaoDelete, setProgressaoDelete] = useState(null);
  const [deletandoId, setDeletandoId] = useState(null);
  const [progressoes, setProgressoes] = useState([]);
  const [pdfResultado, setPdfResultado] = useState(false);
  const [pdfProgressao, setPdfProgressao] = useState(false);
  const [loading, setLoading] = useState(false);
  const [addExemplar, setAddExemplar] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [pc, setPc] = useState(window.innerWidth > 1000);

  useEffect(() => {
    const handleResize = () => {
      setPc(window.innerWidth > 1000);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setLoading(true);
    ListarProgressoes();
  }, []);

  useEffect(() => {
    ListarProgressoes();
  }, [deletandoId, progressaoEdit, resultado, showAdicionar, showEditar, MostrarAlunos]);

  const date = new Date();

  async function ListarProgressoes() {
    try {
      const res = await api.get("/coordenador/listar-progressoes");

      const { progressoes: progressoesData, progressoesComPendencias } = res.data;

      const progressoesAtualizadas = progressoesData.map((p) => {
        if (progressoesComPendencias?.includes(p.id)) {
          return { ...p, emAvaliacao: true };
        }
        return { ...p, emAvaliacao: false };
      });

      setProgressoes(progressoesAtualizadas);
 
    } catch (err) {

      setProgressoes([]);
      console.clear();

    } finally {
      setLoading(false);
    }
  }

  async function DeletarProgressoes(id, pdf, andamento, terminou) {
    if (terminou) {
      return Alert({ tipo: "Alert3", mensagem: "Está progressão já terminou. Nâo é possível deleta-lá" });
    } else {
      const result = await Alert({ tipo: "Alert", mensagem: "Deseja deletar essa progressão?" });
      if (result.isConfirmed) {
        setDeletandoId(id);
        try {
          await api
            .delete(`/professor/deletar-progressao`, {
              params: { id, pdf },
            })
            .then(async (response) => {
              await Alert({
                tipo: "Sucesso2",
                mensagem: `${response.data.mensagem ? response.data.mensagem : "Progressão deletada com sucesso"}`,
                tempo: 1200,
              });
              setDeletandoId(null);
              return await ListarProgressoes();
            })
            .catch((erro) => {
              Alert({
                tipo: "Erro2",
                mensagem: `${erro.response.data.erro ? erro.response.data.erro : "Erro ao deletar a progressão"}`,
              });
              setDeletandoId(null);
            });
        } catch (err) {
          console.log("Erro: ", err);
          setDeletandoId(null);
        }
      }
    }
  }

  function AbrirConfirmacaoDeleteComAlunos(progressao, andamento, terminou, agendada) {
    if (terminou) {
      return Alert({ tipo: "Alert3", mensagem: "Está progressão já terminou. Nâo é possível deleta-lá" });
    }

    setProgressaoDelete(progressao);
    setShowConfirmarDelete(true);
  }

  const Thead = () => (
    <Theader>
      <tr>
        <Th title="Professor">Professor</Th>
        <Th title="Curso">Curso</Th>
        <Th title="Turma">Turma</Th>
        <Th title="Disciplina">Disciplina</Th>
        <Th title="Início">Início</Th>
        <Th title="Limite Entrega">Limite Entrega</Th>
        <Th title="Avaliar">Avaliar</Th>
        <Th title="Ver Alunos">Ver Alunos</Th>
        <Th title="PDF">PDF</Th>
        <Th title="Informações">Informações</Th>
        <Th title="Editar">Editar</Th>
        <Th title="Deletar">Deletar</Th>
      </tr>
    </Theader>
  );

  return (
    <Page>
      <DivMain>
        <Menus>
          <Title>Turmas Progressão Parcial</Title>
          <Buttons>
            <Button
              event={() => {
                Navigate("/home-progressao-coord");
              }}
              width={pc ? "8rem" : "fit-content"}
              fontsize={!pc && "10px"}
              margintop={pc ? "1%" : "8px"}
              placeholder="Voltar"
              backgroundcolor="#1a2e35"
              borderRadius="30px 30px 0px 0px"
            />
            <Button
              event={() => setShowAdicionar(true)}
              width={pc ? "10rem" : ""}
              fontsize={!pc && "10px"}
              margintop={pc ? "1%" : "8px"}
              backgroundcolor="#1a2e35"
              placeholder="Adicionar"
              borderRadius="30px 30px 0px 0px"
            />
          </Buttons>
          <Description2 onClick={() => setAddExemplar(true)}>
            <BsPlayBtnFill color="red" size={36} /> Visão geral <br />
            Progressão
          </Description2>
          {progressoes.length ? (
            <>
              <Description>
                <p>
                  <span className="agendada" />
                  Agendadas
                </p>
                <p>
                  <span className="andamento" />
                  Em Andamento
                </p>
                <p>
                  <span className="emAvaliacao" />
                  Em avaliação
                </p>
                <p>
                  <span className="terminou" />
                  Encerradas
                </p>
              </Description>
            </>
          ) : null}
        </Menus>
        {loading ? (
          <ContainerTable $loading={loading}>
            <Loading />
          </ContainerTable>
        ) : (
          <ContainerTable>
            {progressoes.length ? (
              <Table>
                {Thead()}
                <Tbody>
                  {progressoes?.map((d, i) => {
                    //console.log(d);

                    const dataAtual = new Date();
                    const dataInicio = new Date(d.data_inicio);
                    const dataFim = new Date(d.data_fim);
                    const andamento = dataAtual >= dataInicio && dataAtual <= dataFim;
                    const terminou = dataAtual > dataFim;
                    const agendada = dataInicio > dataAtual;

                    // Adiciona 15 dias a data final
                    const dataFimMais15Dias = new Date(dataFim);
                    dataFimMais15Dias.setDate(dataFimMais15Dias.getDate() + 15);
                    // Verifica se a data atual é maior que a data de fim + 15 dias
                    //const MaisDe15Dias = dataAtual > dataFimMais15Dias;
                    const emAvaliacao = terminou && d.emAvaliacao;
                    const encerrada = terminou && !d.emAvaliacao;

                    const turma = d.turma_rh
                      ? d.turma_rh.split(",")[1]?.trim()?.split("-")?.slice(1)?.join(" - ")
                      : "Sem turma";

                    const curso = d.curso_rh
                      ?
                      d.curso_rh.split(",")[1]
                        .replace(/(TÉCNICO EM|TECNÓLOGO EM)/g, "")
                        .trim()
                      : "Sem curso";

                    const professor =
                      typeof d?.professor === "string"
                        ? d.professor.includes(",")
                          ? d.professor.split(",")[1]?.trim()?.split(" ").slice(0, 2).join(" ")
                          : d.professor.split(" ").slice(0, 2).join(" ")
                        : "Professor inválido";

                    return (
                      <Trbody key={i}>
                        <Td title={professor}>
                          {emAvaliacao ? (
                            <p>
                              <span className="emAvaliacao" />
                              {professor}
                            </p>
                          ) : encerrada ? (
                            <p>
                              <span className="terminou" />
                              {professor}
                            </p>
                          ) : andamento ? (
                            <p>
                              <span className="andamento" />
                              {professor}
                            </p>
                          ) : agendada ? (
                            <p>
                              <span className="agendada" />
                              {professor}
                            </p>
                          ) : (
                            <p>{professor}</p>
                          )}
                        </Td>
                        <Td title={typeof d?.curso_rh === "string" ? curso : "Curso inválido"}>
                          {typeof d?.curso_rh === "string" ? curso : "Curso inválido"}
                        </Td>
                        <Td title={typeof d?.turma_rh === "string" ? turma : "Turma inválida"} className="turma">
                          {typeof d?.turma_rh === "string" ? turma : "Turma inválida"}
                        </Td>
                        <TdDisciplina
                          title={
                            typeof d?.disciplina_rh === "string" ? d.disciplina_rh.split(",")[1] : "Disciplina inválida"
                          }
                        >
                          {typeof d?.disciplina_rh === "string" ? d.disciplina_rh.split(",")[1] : "Disciplina inválida"}
                        </TdDisciplina>
                        <Td title={d?.data_inicio ? format(dataInicio, "dd/MM/yyyy") : "Data inválida"}>
                          {d?.data_inicio ? format(dataInicio, "dd/MM/yyyy") : "Data inválida"}
                        </Td>
                        <Td title={d?.data_fim ? format(dataFim, "dd/MM/yyyy") : "Data inválida"} className="icon">
                          {d?.data_fim ? format(dataFim, "dd/MM/yyyy") : "Data inválida"}
                        </Td>
                        <Td className="icon">
                          <PiListChecksFill
                            onClick={() => {
                              if (terminou) {
                                setResultado(!resultado);
                                setProgressaoEdit(d);
                              } else {
                                Alert({
                                  tipo: "Alert2",
                                  mensagem: `Avaliar somente após o Encerramento: ${format(dataFim, "dd/MM/yyyy")}`,
                                });
                              }
                            }}
                            size={"2rem"}
                            cursor={"pointer"}
                            title={
                              terminou ? "Inserir Resultado" : `Após o Encerramento: ${format(dataFim, "dd/MM/yyyy")}`
                            }
                            color={terminou ? "#000" : "#535353"}
                          />
                        </Td>
                        <Td className="icon">
                          <LuEye
                            onClick={() => {
                              setMostrarAlunos(true);
                              setProgressaoEdit(d);
                            }}
                            size={"2rem"}
                            cursor={"pointer"}
                            title="Ver Alunos"
                          />
                        </Td>
                        <Td className="icon">
                          <FaFilePdf
                            onClick={() => {
                              if (!d?.pdf) return Alert({ tipo: "Alert3", mensagem: "Não há pdf disponí­vel!" });
                              else return (setPdfProgressao(true), setProgressaoEdit(d));
                            }}
                            size={"1.8rem"}
                            cursor={"pointer"}
                            title="Ver PDF"
                            color={d?.pdf ? "#de000e" : "#535353"}
                          />
                        </Td>
                        <Td className="icon">
                          <MdInfo
                            onClick={() => {
                              setShowForm(true);
                              setProgressaoEdit(d);
                            }}
                            size={"1.8rem"}
                            cursor={"pointer"}
                            title={"informações da progressão"}
                            color={"#00a2ff"}
                          />
                        </Td>
                        <Td className="icon">
                          <FiEdit
                            onClick={() => {
                              if (terminou)
                                return Alert({
                                  tipo: "Alert3",
                                  mensagem: `Esta progressão terminou. Não é possível edita-la!`,
                                });
                              else (setShowEditar(true), setProgressaoEdit(d));
                            }}
                            size={"2rem"}
                            // cursor={"pointer"}
                            color={terminou ? "#707070" : "#000"}
                            cursor={terminou ? "not-allowed" : "pointer"}
                            title="Editar"
                          />
                        </Td>
                        <Td className="icon">
                          {deletandoId !== d?.id ? (
                            <MdDelete
                              onClick={() => AbrirConfirmacaoDeleteComAlunos(d, andamento, terminou, agendada)}
                              size={"2rem"}
                              color={
                                // andamento || terminou ? "#535353" : "#000"
                                terminou ? "#535353" : "#000"
                              }
                              cursor={
                                // andamento || terminou ? "not-allowed" : "pointer"
                                terminou ? "not-allowed" : "pointer"
                              }
                              title="Deletar"
                            />
                          ) : (
                            <MdAutoDelete size={"2rem"} cursor={"pointer"} title="Deletando" />
                          )}
                        </Td>
                      </Trbody>
                    );
                  })}
                </Tbody>
              </Table>
            ) : (
              <>
                <Table>{Thead()}</Table>
                <DivText>Nenhuma Progressão Adicionada</DivText>
              </>
            )}
          </ContainerTable>
        )}
      </DivMain>
      {/* Para adicionar uma nova progressão*/}
      <CardProgressao show={showAdicionar} setShow={setShowAdicionar} mode="add" />
      {/* Para editar uma progressão existente*/}
      <CardProgressao show={showEditar} setShow={setShowEditar} mode="edit" progressaoEdit={progressaoEdit} />
      {/* Para ver o PDF da progressão*/}
      <CardVerPdfProgressao Show={pdfProgressao} setShow={setPdfProgressao} progressaoEdit={progressaoEdit} />
      {/* Para ver o resultado da progressão*/}
      <CardGerarResultadoProgressao show={resultado} setShow={setResultado} progressaoEdit={progressaoEdit} />
      {/* Para ver os alunos da progressão*/}
      <CardListarAlunosPP
        MostrarAlunos={MostrarAlunos}
        setMostrarAlunos={setMostrarAlunos}
        progressaoEdit={progressaoEdit}
      />
      {/* Para confirmar exclusão mostrando alunos da progressão*/}
      <CardListarAlunosPP
        MostrarAlunos={showConfirmarDelete}
        setMostrarAlunos={(show) => {
          setShowConfirmarDelete(show);
          if (!show) setProgressaoDelete(null);
        }}
        progressaoEdit={progressaoDelete || {}}
        modoExclusao={true}
        deletando={deletandoId === progressaoDelete?.id}
        onConfirmarExclusao={() => {
          setShowConfirmarDelete(false);
          DeletarProgressoes(progressaoDelete?.id, progressaoDelete?.pdf, false, false);
        }}
      />
      {/* Para adicionar o exemplar da progressão*/}
      <InsirirVerDocExemplar show={addExemplar} setShow={setAddExemplar} perfil={"coord"} />
      <CardVerInformacoes show={showForm} setShow={setShowForm} progressaoEdit={progressaoEdit} />
    </Page>
  );
};
